import React from "react";
import { FaCat } from "react-icons/fa";

export default function Blocked() {
  // 🔹 Локальні стилі для компонента
  const styles = {
    container: {
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      background: "linear-gradient(135deg, #dbeafe, #bbf7d0)",
      color: "#333",
      textAlign: "center",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
    },
    catIcon: {
      color: "#4caf50",
      fontSize: "60px",
      animation: "breathing 3s ease-in-out infinite",
    },
    title: {
      fontSize: "2.5rem",
      color: "#2e7d32",
      marginTop: "10px",
    },
    text: {
      fontSize: "1.2rem",
      marginTop: "10px",
    },
    keyframes: `
      @keyframes breathing {
        0% { transform: scale(1); }
        50% { transform: scale(1.15); }
        100% { transform: scale(1); }
      }
    `,
  };

  return (
    <>
      {/* 🔸 Додаємо стилі з keyframes прямо в компонент */}
      <style>{styles.keyframes}</style>

      <div style={styles.container}>
        <FaCat style={styles.catIcon} />
        <h1 style={styles.title}>Незабаром відкриття MyZooShop!</h1>
        <p style={styles.text}>
          Ми готуємо найкращі товари для ваших улюбленців ❤️
        </p>
      </div>
    </>
  );
}
